import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { JwtPayload, jwtDecode } from "jwt-decode";
import { ROLES } from "../../ts/enums/roles";

interface RequiredAuthProps {
  allowedRoles: ROLES[];
}

interface JWTContent extends JwtPayload {
  sub: string;
  email: string;
  role: ROLES;
}

const RequireAuth = ({ allowedRoles }: RequiredAuthProps) => {
  const { accessToken, isLoggedIn } = useAuth();
  const location = useLocation();

  const decoded =
    accessToken !== null ? jwtDecode<JWTContent>(accessToken) : undefined;

  const role = decoded?.role;

  //If the role is not undefined and the role is included in allowed roles -> continue to outlet
  //If that is false but the token is decoded it means the user is logged in but doesnt have permission -> unauthorized
  //If the decoded token is undefined it means the user is not logged in -> login
  return role && allowedRoles.includes(role) ? (
    <Outlet />
  ) : isLoggedIn() ? (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  ) : (
    //Makes sure to navigate the user to login if not signed in
    // state and replace make sure the back button returns to original page
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default RequireAuth;
